<template>
  <div ref="echart01" style="width:650px; height:450px;"></div>
</template>

<script>
export default {
  props: {
    data08:
            {
              type: Object
            }
  },
  mounted() {
    debugger
    let chart01 = this.$echarts.init(this.$refs.echart01)
    // let xdata = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
    // let ydata1 = [2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000, 2000, 3000, 4200, 3200, 3800, 2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000,3000]
    // let ydata2 = [1000, 800, 800, 900, 600, 1000, 3000, 1030, 356, 1900, 4000, 3000, 100, 1000, 1200, 1200, 1800,1000, 800, 800, 900, 600, 1000, 3000, 1030, 356, 1900, 4000, 3000, 100, 1000, 1200]
    let xAxisData = this.data08.xAxisData
    let xdata=[]
    xAxisData.forEach(e=>{
      xdata.push(e.substring(5))
    })
    let ydata1 = this.data08.ydata1
    let ydata2 = this.data08.ydata2
    let ydata3=this.data08.ydata3;
    function subtract(){
      let arr=[]
      ydata3.forEach((value, index)=>{
        arr.push(ydata3[index]-ydata1[index])
      })
      return arr;
    }
    ydata2=subtract();
    console.log("ydata1",ydata1)
    console.log("ydata2",ydata2)
    console.log("ydata3",ydata3);
    function getTableLine(num) {
      var list = [];
      var bottom = 130;
      var height = 25;
      for (var i = 0; i < num; i++) {
        list.push({
          type: 'line',
          bottom: bottom - i * height,
          right: 26,
          style: {
            fill: '#333'
          },
          shape: {
            x1: 0,
            y1: 0,
            x2: 606,
            y2: 0
          }
        });
      }
      return list;
    }
    let option={}
    if (ydata1.length == 0||ydata2.length == 0 ) {  //暂无数据
      var lineList = getTableLine(5); //计算渲染条线数
      lineList.push({
        type: 'line',
        bottom: 30,
        left: 16,
        style: {
          fill: '#333'
        },
        shape: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 100
        }
      });
      option = {
        title: {
          text: '暂无数据',
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
            color: 'black'
          }
        }
      }
    } else {
      option = {
        //   backgroundColor: "#FFF",
        //color: ['#5470C6', '#91CC75', '#EE6666'],
        grid: {
          top: '9%',
          bottom: '29%',
          left: '16%',
          right: '4%'
        },
        // legend: {
        //   top: 0
        // },
        legend: {
          align: "right",
          itemGap: 12,
          orient: "vertical",
          textStyle: { color: "#000" },
          bottom: 30,
          left: 19,
          data: ["已打卡", "未打卡", "排班数量"]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        // tooltip: {
        //   trigger: 'axis',
        //   confine:true,
        //   label: {
        //     show: true
        //   },
        //   axisPointer: {
        //     type: 'shadow'
        //   }
        // },
        xAxis: {
          boundaryGap: true, //默认，坐标轴留白策略
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
            }
          },
          // splitLine: {
          //   show: true,
          //   lineStyle: {
          //     type: 'dashed',
          //     color: 'rgba(33,148,246,0.2)'
          //   }
          // },
          // axisTick: {
          //   show: false,
          //   alignWithLabel: true
          // },
          axisTick: {
            length: 100
          },
          axisLabel: {
            margin: 0,
            interval: 0,
            axisPointer: {
              type: 'shadow'
            },
            formatter: function (value, index) {
              var indexNum = 0;
              for (var i = 0; i < xdata.length; i++) {
                if (value === xdata[i]) {
                  indexNum = i;
                }
              }
              return (
                      '{table|' +
                      value +
                      '}\n{table|' +
                      ydata1[indexNum] +
                      '}\n{table|' +
                      ydata2[indexNum] +
                      '}\n{table|' +
                      ydata3[indexNum] +
                      '}\n{table|' +
                      '}'
              );
            },
            rich: {
              table: {
                height: 25,
                align: 'center',
                verticalAlign: 'middle'
              }
            }
          },
          data: xdata
        },
        graphic: lineList,
        yAxis: {
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: 'rgb(245,250,254)'
            }
          }
        },
        series: [
          {
            name:'已打卡',
            type: 'line',
            symbol: 'circle',
            symbolSize: 7,
            lineStyle: {
              color: 'rgb(89,163,239)',
              shadowBlur: 12,
              shadowColor: 'rgb(89,163,239,0.9)',
              shadowOffsetX: 1,
              shadowOffsetY: 1
            },
            itemStyle: {
              normal:{
                label : {
                  show: true // 在折线拐点上显示数据
                }
              },
              color: 'rgb(89,163,239)',
              borderWidth: 1,
              borderColor: '#fff'
            },
            // label: {
            //   show: false,
            //   distance: 1,
            // },
            data: ydata1
          },
          {
            name: '未打卡',
            type: 'line',
            symbol: 'circle',
            symbolSize: 7,
            lineStyle: {
              color: 'rgb(253,45,45)',
              shadowBlur: 12,
              shadowColor: 'rgb(253,45,45,0.9)',
              shadowOffsetX: 1,
              shadowOffsetY: 1
            },
            itemStyle: {
              normal:{
                label : {
                  show: true // 在折线拐点上显示数据
                }
              },
              color: 'rgb(253,45,45)',
              borderWidth: 1,
              borderColor: '#FFF'
            },
            // label: {
            //   show: false,
            //   distance: 1
            // },
            data: ydata2
          },
          {
            name: "排班数量",
            type: "bar",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                        0,
                        1,
                        0,
                        0,
                        [
                          {
                            offset: 0,
                            color: "#f9fbfe"
                          },
                          {
                            offset: 1,
                            color: "#8b79fe"
                          }
                        ],
                        false
                ) // 渐变
              }
            },
            label: {
              show: true,
              position:"top"
            },
            labelLine: {
              show:true
            },
            data: ydata3
          },
        ]
      }
    }

    chart01.setOption(option, true)
  }
}
</script>

<style></style>
